import { useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { AdhaarOCRVerficiationAction } from '../APIs/action';

const useOCRProcessing = (options = {}) => {
    const {
        consent = 'Y'
    } = options;

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [extractedData, setExtractedData] = useState({});
    const [uploadedFile, setUploadedFile] = useState(null);

    const processOCRDocument = useCallback(async (file) => {
        setIsLoading(true);
        setError('');
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'];
        if (!allowedTypes.includes(file.type)) {
            setError('Please upload a valid file (PNG, JPG, JPEG, PDF).');
            setIsLoading(false);
            return false;
        }
        // const maxSize = 3 * 1024 * 1024; // 3MB in bytes
        // if (file.size > maxSize) {
        //     setError('File size should not exceed 3MB.');
        //     setIsLoading(false);
        //     return false;
        // }
        const formData = new FormData();
        formData.append('file_front', file, file.name);
        formData.append('consent', consent);

        const response = await AdhaarOCRVerficiationAction(formData);

        if (response && !response.error && response.data) {
            const { data } = response;
            const extractedInfo = {
                full_name: data.name,
                dob: data.date_of_birth,
                gender: data.gender,
                guardian_name: data.guardian_name,
                address: data.address,
                document_id: data.document_id,
                document_type: data.document_type
            };
            
            setExtractedData(extractedInfo);
            setIsLoading(false);
            toast.success(response?.message);
            return true;
        } else {
            const errorMessage = response?.message || 'Failed to extract document details';
            setError(errorMessage);
            setIsLoading(false);
            toast.error(errorMessage);
            return false;
        }
    }, [consent]);

    const handleFileUpload = async (file) => {
        if (!file) return false;

        setUploadedFile(file);
        setError('');
        return await processOCRDocument(file);
    };

    const resetOCR = () => {
        setIsLoading(false);
        setError('');
        setExtractedData({});
        setUploadedFile(null);
    };

    return {
        isLoading,
        error,
        extractedData,
        uploadedFile,
        handleFileUpload,
        resetOCR,
        setExtractedData,
        setError
    };
};

export default useOCRProcessing;